'use client'

import type { ReactNode } from 'react'
import { cx } from './utils/cx'
import { Logo } from './Logo'
import { NavItem } from './NavItem'
import { UserChip, type UserTier } from './UserChip'

export interface TopBarItem {
  key: string
  label: ReactNode
  href?: string
  onClick?: () => void
}

interface TopBarProps {
  active?: string
  items?: TopBarItem[]
  user?: { initials: string; name: string }
  tier?: UserTier
  size?: 'sm'
  children?: ReactNode
  // Custom right-side slot (e.g. app-specific dropdown). Takes precedence
  // over the default UserChip render when provided.
  right?: ReactNode
}

export function TopBar({ active, items, user, tier = 'pro', size, children, right }: TopBarProps) {
  const defaultItems: TopBarItem[] = items || [
    { key: 'send', label: 'Send' },
    { key: 'receive', label: 'Receive' },
    { key: 'vault', label: 'Vault' },
    { key: 'activity', label: 'Activity' }
  ]
  return (
    <header className={cx('st-topbar', size)}>
      <Logo size={size} />
      <nav className="st-nav">
        {children ||
          defaultItems.map((it) => (
            <NavItem key={it.key} on={active === it.key} href={it.href || '#'} onClick={it.onClick}>
              {it.label}
            </NavItem>
          ))}
      </nav>
      {right ?? (user && <UserChip {...user} tier={tier} />)}
    </header>
  )
}
